import { Col, Modal, Row } from "antd"
import useLoaderWatchers from "modules/loader-watchers/hooks/useLoaderWatchers"
import { loadingSelector } from "modules/loader-watchers/selectors"
import { useEffect } from "react"
import { useTranslation } from "react-i18next"
import { useDispatch, useSelector } from "react-redux"
import { notification } from "ui/Notification"
import Spinner from "../../../../../src/components/common/Spinner"
import { useGoogleCalendarAuth } from "../../../../hooks/useGoogleCalendarAuth"
import { deleteGoogleCalendarAccount, fetchGoogleCalendarAccounts, manageGoogleCalendarConnection } from "../../../../store/google-calendar"
import styles from "./GoogleCalendar.module.css"
import { GoogleCalendarAccounts } from "./GoogleCalendarAccounts"
export const GoogleCalendar = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const { login, setGoogleAccounts } = useGoogleCalendarAuth()

  const { accounts } = useSelector((state) => state.googleCalendar)
  const isLoading = useSelector(loadingSelector("googleCalendar"))
  useLoaderWatchers({ watchers: "googleCalendar" })

  useEffect(() => {
    dispatch(fetchGoogleCalendarAccounts())
  }, [dispatch])

  const handleAddCalendarAccount = () => {
    login()
  }

  const handleDeleteCalendarAccount = (accountId, email) => {
    if (!accountId) {
      setGoogleAccounts((prevAccounts) => prevAccounts.filter((account) => account.email !== email))
      return
    }

    Modal.confirm({
      title: t("google_calendar.delete_account_title"),
      content: <div dangerouslySetInnerHTML={{ __html: t("google_calendar.delete_account_info", { accountEmail: email }) }} />,
      okText: t("global.confirm"),
      cancelText: t("global.cancel"),
      onOk: () => {
        dispatch(deleteGoogleCalendarAccount(accountId))
          .then(() => {
            notification.success({
              message: t("google_calendar.delete_account_success")
            })
          })
          .catch(() => {
            notification.error({
              message: t("google_calendar.delete_account_error")
            })
          })
      }
    })
  }


  const handleGoogleCalendarConnection = (accountId, active) => {
    Modal.confirm({
      title: t("google_calendar.update_account_title"),
      content: t(active ? "google_calendar.disconnect_account_info" : "google_calendar.connect_account_info"),
      okText: t(active ? "global.disconnect" : "global.connect"),
      cancelText: t("global.cancel"),
      onOk: () => {
        dispatch(
          manageGoogleCalendarConnection({
            accountId,
            active: !active
          })
        )
          .then(() => {
            notification.success({
              message: t(active ? "google_calendar.disconnect_message" : "google_calendar.success_message")
            })
          })
          .catch(() => {
            notification.error({
              message: t("google_calendar.update_account_error")
            })
          })
      }
    })
  }

  return (
    <Row className={styles.googleCalendarContainer} gutter={[26, 26]}>
      {/* Show Spinner when loading */}
      {isLoading && <Spinner className="bg-white bg-opacity-50 w-100 h-100" absolute />}

      {/* Left Section: Google Calendar Accounts */}
      <Col span={24}>
        <GoogleCalendarAccounts
          googleAccounts={accounts}
          t={t}
          handleAddCalendarAccount={handleAddCalendarAccount}
          handleDeleteCalendarAccount={handleDeleteCalendarAccount}
          handleGoogleCalendarConnection={handleGoogleCalendarConnection}
        />
      </Col>
    </Row>
  )
}
